import ReactGA from 'react-ga';

import config from '@occc/config';

export class GoogleAnalytics {
  initialized: boolean;

  constructor() {
    this.initialized = false;
  }

  initialize = () => {
    if (config.google.analyticsId) {
      ReactGA.initialize(config.google.analyticsId);
      this.initialized = true;
      this.recordPageView(window.location.pathname);
    }
  };

  recordPageView = (path: string) => {
    if (this.initialized) {
      ReactGA.pageview(path);
    }
  };
}

const instance = new GoogleAnalytics();

export const initialize = instance.initialize;
export const recordPageView = instance.recordPageView;
